import { render } from "./inputitems.vue?vue&type=template&id=4254b601"
import script from "./inputitems.vue?vue&type=script&lang=js"
export * from "./inputitems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__